import React from 'react';

export default function Footer({ onNavigate }) {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand">
		<div className="academic-brand" onClick={() => onNavigate('folders')}>
          <div className="brand-logo-container">
            <img src="/assets/icon.png" alt="GangaTricks Logo" className="brand-logo-img" />
          </div>
          <div className="brand-titles">
            <span className="brand-name">GangaTricks</span>
			<span className="brand-portal">Keep failure at bay with us</span>

          </div>
        </div>
          <p className="footer-description">
            We are committed to simplified learning and friction free experience, accessibility, affordability, fast procurement, innovation and learning flexibility. Our vision is to help you mine your max potential.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-links">
          <h4 className="footer-heading">Quick Links</h4>
          <ul>
            <li>
              <button onClick={() => onNavigate('folders')} className="footer-link-btn">
                Browse Folders
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate('contact')} className="footer-link-btn">
                Contact Us
              </button>
            </li>
          </ul>
        </div>

        {/* Social / Extra Section */}
        <div className="footer-social">
          <h4 className="footer-heading">Connect</h4>
          <div className="social-icons">
            <a href="#" aria-label="Twitter" className="social-link">Twitter</a>
            <a href="#" aria-label="GitHub" className="social-link">GitHub</a>
            <a href="#" aria-label="Discord" className="social-link">Discord</a>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Section */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} GangaTricks. All rights reserved.</p>
      </div>
    </footer>
  );
}